import { render, staticRenderFns } from "./LensPublicMetricTable.vue?vue&type=template&id=6b5ad882&scoped=true"
import script from "./LensPublicMetricTable.vue?vue&type=script&lang=js"
export * from "./LensPublicMetricTable.vue?vue&type=script&lang=js"
import style0 from "./LensPublicMetricTable.vue?vue&type=style&index=0&id=6b5ad882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5ad882",
  null
  
)

export default component.exports